export const IMAGE_MANIFEST = {
  "/images/hero-bg.jpg": "/images/hero-bg.webp",
  "/images/nlc-logo.png": "/images/nlc-logo.webp"
};